/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { PlusOutlined } from '@ant-design/icons'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { Tooltip, Select, Row, Col, Form, Typography, Button } from 'antd'
import { CustomStockInput, CustomSelect, CustomModal, FootPrintForm } from 'src/components'
import { createFootPrint, getFootPrintHistory, getFootPrintVsCompensationData, resetFootPrintCreateState } from 'src/features'

import styles from '../RegisterFootPrint.module.scss'

const { Option } = Select
const { Text } = Typography

const SmallRegisterFootPrintForm = ({ footPrintTypes }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalFootprint, setModalFootprint] = useState(null)
  const [co2Amount, setCO2Amount] = useState(null)
  const [showAmountError, setShowAmountError] = useState(false)

  const { success } = useAppSelector((state) => state.footprint.createFootPrint)

  useEffect(() => {
    if (success) {
      dispatch(getFootPrintVsCompensationData())
      dispatch(getFootPrintHistory())
      showNotification('success', t('general.OperationSuccess'))
      dispatch(resetFootPrintCreateState())
    }
  }, [success])


  const handleInputChange = (value: number) => {
    setCO2Amount(value)
    setShowAmountError([null, 0].includes(value))
  }

  const resetForm = () => {
    form.resetFields()
    setCO2Amount(null)
    setIsModalVisible(false)
    setModalFootprint(null)
  }

  const handleSubmit = (params) => {
    setIsModalVisible(true)
    setModalFootprint(params)
  }

  const onFinish = (values: any) => {
    if ([null, 0].includes(co2Amount) || showAmountError) {
      setShowAmountError(true)
    } else {
      setShowAmountError(false)
      const params = {
        footprint_type: { id: values.footprintType },
        co2_amount: co2Amount,
        name: null,
        description: null
      }
      handleSubmit(params)
    }
  }

  const handleFormSubmit = (values) => {
    dispatch(createFootPrint(values))
    resetForm()
  }

  return (
    <div>
      <Form
        name='basic'
        onFinish={onFinish}
        autoComplete='off'
        form={form}
      >
        {/* FootPrint Type Select */}
        <div className={styles['select-type-margin']}>
          <CustomSelect
            placeholder={'Select Foot Print Type'}
            name='footprintType'
            required={true}
          >
            {footPrintTypes.map((item) => (
              <Option value={item.id} key={item.id}>{item.name}</Option>
            ))}
          </CustomSelect>
        </div>

        {/* Co2 Amount */}
        <div className='mt-3'>
          <Row>
            <Col span={7}>
              <div className='mt-2'>
                <Text strong>{t('footPrint.CO2Amount')}</Text>
              </div>
            </Col>
            <Col span={15}>
              <CustomStockInput
                name='co2_amount'
                suffix={'tCO2e'}
                value={co2Amount}
                setValue={handleInputChange}
              />
              {showAmountError && (
                <Text type='danger'>{t('general.RequiredValidation')}</Text>
              )}
            </Col>
            <Col span={2}>
              <Tooltip title={t('footPrint.AddRegister')} color={'blue'}>
                <Button
                  type='primary'
                  htmlType='submit'
                  shape='circle'
                  className='radius-100'
                  icon={<PlusOutlined />}
                />
              </Tooltip>
            </Col>
          </Row>
        </div>
      </Form>

      {/* Small Register */}
      <CustomModal
        title={t('footPrint.AddRegister')}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        open={isModalVisible}
      >
        <FootPrintForm
          handleSubmit={handleFormSubmit}
          isLoading={false}
          isFromRegister={true}
          footPrint={modalFootprint}
        />
      </CustomModal>
    </div>
  )
}

export default SmallRegisterFootPrintForm
